<script>
    import Router from 'svelte-spa-router'
    import routes from "./routes";
    import { registerPageState } from './registration/registeredUser.js'
    import { organizationsPageState } from "./organizations/organizationsState";
    import { usersPageState } from "./users/usersState";
    import {changePage} from "./common/navigation";
    import {summaryPageState} from "./summary/summary";

    function conditionsFailed(event) {
        if (!$registerPageState) {
            return changePage('/#/registration')
        } else if (!$organizationsPageState) {
            return changePage('/#/organizations')
        } else if (!$usersPageState) {
            return changePage('/#/users')
        } else if (!$summaryPageState) {
            return changePage('/#/summary')
        } else {
            return changePage('/#/registration')
        }
    }
</script>

<Router {routes} on:conditionsFailed={conditionsFailed}/>
<style>
</style>
